import { useEffect, useRef, useState } from 'react';
import Enllac from 'components/corporatiu/Enllac';
import clsx from 'clsx';
import Icona from 'components/corporatiu/ui/Icona';
import styles from './menusecundari.module.scss';
import { useViewport } from 'hooks/corporatiu/useViewport';
import __isEmpty from 'lodash/isEmpty';
import { titolSeccio, peuSideMenu } from './contentMenu.jsx';

const contingutMenu = (seccio, opcio, openDesplegable, setOpenDesplegable, isMobile) => {
    const toggleAccordion = () => {
        setOpenDesplegable(!openDesplegable);
    };
    switch (seccio) {
        case 'corporatiu':
        case 'atencio':
            return (
                <>
                    <a
                        className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'inici' })}
                        href='/corporatiu/ca/el-grup/'
                    >
                        <span>Coneix-nos</span>
                    </a>
                    <a className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'atencio' })} href='/atencio/'>
                        <span>Atenció a l&apos;audiència</span>
                    </a>
                    <Enllac className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'premsa' })} href='/premsa/'>
                        <span>Premsa</span>
                    </Enllac>
                    <a
                        className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'marato' })}
                        href='https://www.3cat.cat/tv3/marato/'
                    >
                        <span>La Marató</span>
                    </a>
                </>
            );
        case 'tv3':
            return (
                <>
                    <Enllac
                        className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'inici', [styles.inici]: !isMobile })}
                        href='https://www.3cat.cat/tv3/'
                    >
                        <span>Inici</span>
                    </Enllac>
                    <Enllac
                        className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'directes' })}
                        href='/3cat/directes/'
                    >
                        <span>Directes</span>
                    </Enllac>
                    <Enllac
                        className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'programacio' })}
                        href='/tv3/programacio/canal-tv3/'
                    >
                        <span>Programació</span>
                    </Enllac>
                    <Enllac
                        className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'cataleg' })}
                        href='/3cat/tot-cataleg/tot/'
                    >
                        <span>Catàleg</span>
                    </Enllac>
                    <div className={clsx(styles.seccDesplegable, { [styles.obert]: openDesplegable })}>
                        <button
                            className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'canals' })}
                            aria-expanded={openDesplegable}
                            onClick={toggleAccordion}
                        >
                            <span>Canals</span>
                        </button>
                        <ul className={clsx(styles.desplegable)} aria-label='Llistat de canals de TV3'>
                            <li>
                                <Enllac href='/3cat/directes/tv3/'>TV3</Enllac>
                            </li>
                            <li>
                                <Enllac href='/3cat/directes/3catinfo-tv/'>3CatInfo</Enllac>
                            </li>
                            <li>
                                <Enllac href='/3cat/directes/esport3/'>Esport3</Enllac>
                            </li>
                            <li>
                                <Enllac href='/3cat/directes/33/'>33</Enllac>
                            </li>
                            <li>
                                <Enllac href='/3cat/directes/sx3/'>SX3</Enllac>
                            </li>
                        </ul>
                    </div>
                </>
            );
        case 'catradio':
            return (
                <>
                    <Enllac
                        className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'inici', [styles.inici]: !isMobile })}
                        href='https://www.3cat.cat/catradio/'
                    >
                        <span>Inici</span>
                    </Enllac>
                    <Enllac
                        className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'directes' })}
                        href='/3cat/directes/'
                    >
                        <span>Directes</span>
                    </Enllac>
                    <Enllac
                        className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'programacio' })}
                        href='/catradio/programacio/catalunya-radio/'
                    >
                        <span>Programació</span>
                    </Enllac>
                    <div className={clsx(styles.seccDesplegable, { [styles.obert]: openDesplegable })}>
                        <button
                            className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'emissores' })}
                            aria-expanded={openDesplegable}
                            onClick={toggleAccordion}
                        >
                            <span>Emissores</span>
                        </button>
                        <ul className={clsx(styles.desplegable)} aria-label="Llistat d'emissores de Catalunya Ràdio">
                            <li>
                                <Enllac href='/3cat/directes/catalunya-radio/'>Catalunya Ràdio</Enllac>
                            </li>
                            <li>
                                <Enllac href='/3cat/directes/3catinfo-radio/'>3CatInfo</Enllac>
                            </li>
                            <li>
                                <Enllac href='https://www.3cat.cat/catradio/icat/'>iCat</Enllac>
                            </li>
                            <li>
                                <Enllac href='https://www.3cat.cat/catradio/catalunya-musica/'>Catalunya Música</Enllac>
                            </li>
                        </ul>
                    </div>
                    <Enllac
                        className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'cataleg' })}
                        href='/3cat/podcasts/'
                    >
                        <span>Catàleg</span>
                    </Enllac>
                </>
            );
        case 'avis-legal':
            return (
                <>
                    {opcio === 'informacio-general' ? (
                        <h1 className={styles.titolDesktop}>
                            <Enllac href='/avis-legal/'>
                                <span>Avís legal</span>
                            </Enllac>
                        </h1>
                    ) : (
                        <Enllac className={styles.titolDesktop} href='/avis-legal/'>
                            <span>Avís legal</span>
                        </Enllac>
                    )}
                    <Enllac
                        className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'informacio-general' })}
                        href='/avis-legal/'
                    >
                        <span>Informació general</span>
                    </Enllac>
                    <Enllac
                        className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'privacitat' })}
                        href='/avis-legal/privacitat/dades/'
                    >
                        <span>Privacitat</span>
                    </Enllac>
                    <Enllac
                        className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'cookies' })}
                        href='/avis-legal/cookies/'
                    >
                        <span>Cookies</span>
                    </Enllac>
                    <Enllac
                        className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'participacions' })}
                        href='/avis-legal/participacions-i-concursos/'
                    >
                        <span>Participacions i concursos</span>
                    </Enllac>
                    <Enllac
                        className={clsx(styles.seccLink, { [styles.seccSelected]: opcio === 'menors' })}
                        href='/avis-legal/menors/'
                    >
                        <span>Menors</span>
                    </Enllac>
                </>
            );
    }
};

const MenuSecundariWrapper = (props) => {
    const { seccio, opcio } = props;

    const colorText = seccio === 'tv3' ? 'blanc' : 'negre';

    switch (seccio) {
        case 'tv3':
            colorText === 'blanc';
            break;
        default:
            colorText === 'negre';
            break;
    }

    const { isMobile } = useViewport();

    const [isSideMenuOpen, setIsSideMenuOpen] = useState('initial'); // 'opened', 'closed', 'closing', 'initial'

    const [openDesplegable, setOpenDesplegable] = useState(false);

    const wrapperClass = clsx(styles.wrapper, {
        [styles[seccio]]: !__isEmpty(seccio),
        [styles[colorText]]: colorText
    });

    const sideMenuClass = clsx({
        [styles.sideMenu]: true,
        [styles.isOpen]: isSideMenuOpen === 'opened',
        [styles.isClosed]: isSideMenuOpen === 'closed',
        [styles.initial]: isSideMenuOpen === 'initial',
        [styles.isClosing]: isSideMenuOpen === 'closing'
    });

    const tancarMenuLateral = () => {
        setIsSideMenuOpen('closing');
        setTimeout(() => {
            setIsSideMenuOpen('closed');
        }, 500);
    };

    const sideMenuRef = useRef(null);

    const accessibilityRefs = {
        closeMenu: useRef(null),
        openMenu: useRef(null)
    };

    const setFocusTrap = () => {
        const focusableElements = sideMenuRef.current.querySelectorAll(
            'a[href], button:not([disabled]), textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select'
        );
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        const handleClickOutside = (e) => {
            if (e.target.classList.contains(styles.isOpen)) {
                tancarMenuLateral();
            }
        };

        sideMenuRef.current.addEventListener('mousedown', (e) => {
            handleClickOutside(e);
        });

        sideMenuRef.current.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' || e.keyCode === 27) {
                tancarMenuLateral();
            }

            const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) {
                // Shift + Tab
                if (document.activeElement === firstElement) {
                    lastElement.focus();
                    e.preventDefault();
                }
            } else {
                // Tab
                if (document.activeElement === lastElement) {
                    firstElement.focus();
                    e.preventDefault();
                }
            }
        });
    };

    useEffect(() => {
        if (isSideMenuOpen === 'opened') {
            setFocusTrap();
            document.body.style.overflow = 'hidden';
            accessibilityRefs.closeMenu.current?.focus();
        } else if (isSideMenuOpen === 'closed') {
            document.body.style.overflow = 'auto';
            accessibilityRefs.openMenu.current?.focus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSideMenuOpen]);

    return (
        <nav aria-label='Menú secundari' className={wrapperClass} id='navegacio-secundari'>
            <div className={styles.secundari}>
                <div className={styles.seccions}>{contingutMenu(seccio, opcio, openDesplegable, setOpenDesplegable)}</div>
            </div>
            <div className={styles.secundariMobile}>
                <div className={styles.mainmenu} aria-label='Menu desplegable'>
                    <button
                        data-testid='boto-obre-menu'
                        ref={accessibilityRefs.openMenu}
                        className={styles.ico_menu}
                        onClick={(e) => {
                            setIsSideMenuOpen('opened');
                        }}
                        aria-expanded={isSideMenuOpen === 'opened'}
                        aria-controls='mainMenu'
                    >
                        <Icona icona='menu' alt='Menu' isBlanc={true} mida={24} />
                    </button>
                </div>
                {titolSeccio(seccio, opcio)}
            </div>
            {isMobile && (
                <div className={sideMenuClass} role='dialog' aria-modal='true' aria-label='Menú lateral' ref={sideMenuRef}>
                    <div className={styles.contentMenu}>
                        <div className={styles.headSideMenu}>
                            <div>
                                <button
                                    ref={accessibilityRefs.closeMenu}
                                    className={styles.ico_tanca}
                                    onClick={(e) => {
                                        tancarMenuLateral();
                                    }}
                                    aria-controls='mainMenu'
                                >
                                    <Icona icona='tanca' alt='Tanca' isBlanc={true} ariaHidden={true} />
                                    <span className='sr-only'>Tanca menú de navegació</span>
                                </button>
                            </div>
                            {titolSeccio(seccio, opcio, isMobile)}
                        </div>
                        <div className={styles.seccionsMobile}>
                            {contingutMenu(seccio, opcio, openDesplegable, setOpenDesplegable, isMobile)}
                        </div>
                        {peuSideMenu()}
                    </div>
                </div>
            )}
        </nav>
    );
};

const MenuSecundari = ({ isSideMenuOpen, setIsSideMenuOpen, seccio, opcio, openDesplegable, setOpenDesplegable }) => {
    return (
        <>
            <MenuSecundariWrapper
                isSideMenuOpen={isSideMenuOpen}
                seccio={seccio}
                setIsSideMenuOpen={setIsSideMenuOpen}
                opcio={opcio}
                openDesplegable={openDesplegable}
                setOpenDesplegable={setOpenDesplegable}
            />
        </>
    );
};

export default MenuSecundari;
